import { render, staticRenderFns } from "./s05.vue?vue&type=template&id=136cdf5d"
import script from "./s05.vue?vue&type=script&lang=js"
export * from "./s05.vue?vue&type=script&lang=js"
import style0 from "./s05.vue?vue&type=style&index=0&id=136cdf5d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports